import React from 'react'

function AddMoveIn() {
  return (
    <div>AddMoveIn</div>
  )
}

export default AddMoveIn